export default __webpack_public_path__ + "static/media/gallery_01.98074da0.jpg";